<!-- fatura bilgileri formu -->
<template>
    <form @submit.prevent="saveInvoiceInfo" :disabled="loading">
        <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{translate('invoiceInfo.invoiceInfo')}}</h5>
                <button type="button" class="close" data-dismiss="modal" :aria-label="translate('close')" @click="close()">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body" style="height:500px; overflow-y: auto;">
                <div class="col-12">
                    <div class="form-group row">
                        <div class="col">
                            <label class="col-form-label col-sm-3">{{translate('invoiceInfo.invoiceTitle')}}</label>
                            <div class="col">
                                <input v-model="data.Name" type="text" class="form-control" required />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col">
                            <label class="col-form-label col-sm-3">{{translate('draftEyp.province')}}</label>
                            <div class="col">
                                <input v-model="data.City" type="text" class="form-control" required />
                            </div>
                        </div>
                        <div class="col">
                            <label class="col-form-label col-sm-3">{{translate('draftEyp.district')}}</label>
                            <div class="col">
                                <input v-model="data.District" type="text" class="form-control" required />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col">
                            <label class="col-form-label col">{{translate('invoiceInfo.taxNo')}}</label>
                            <div class="col">
                                <input v-model="data.TaxNo" type="text" class="form-control" required />
                            </div>
                        </div>
                        <div class="col">
                            <label class="col-form-label col">{{translate('invoiceInfo.taxAdmin')}}</label>
                            <div class="col">
                                <input v-model="data.TaxAdmin" type="text" class="form-control" required />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col">
                            <label class="col-form-label col-sm-3">{{translate('invoiceInfo.invoiceAddress')}}</label>
                            <div class="col">
                                <input v-model="data.Address" type="text" class="form-control" required />
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
            <div class="modal-footer footer-button-container"> 
                <button type="button"  class="btn btn-secondary" @click="close()" data-dismiss="modal">
                    {{translate('close')}}
                </button>
                <button type="submit"  class="btn btn-primary">
                    {{translate('save')}}
                </button>
            </div>
            </div>
        </div>
        </div>
    </form>
</template>

<script>
import formMixin from "../formMixin.js";
import axios from 'axios';

export default {
    mixins: [formMixin],
    components: {
    },
    created() {
        this.data = Object.assign({}, this.model);
    }, 
    props: {
          value : Object,
          model: Object,
      },
    data() {
        return {
            loading: false, 
            data: {}
        };
    },
    methods: {
        saveInvoiceInfo(){
            axios.post("/account/updatebillinginfo", this.data).then(x => {
            if(x.data){
               alert(this.translate('messages.invoiceSaveSuccess'))
            }else{
                alert(this.translate('errors.invoiceSaveFail'))
            }
        })
            this.$emit('saveInvoiceInfo', this.data)
            this.$emit('close');
        },
        close(){
            this.$emit('close');
        }
    },
};
</script>
